import { Pipe, PipeTransform } from '@angular/core';
enum status {
  pending = 'Pendiente de realizar',
  running = 'En ejecución',
  finished = 'Por Finalizar',
}
@Pipe({
  name: 'status_task',
})
export class Status_taskPipe implements PipeTransform {
  transform(value: any) {
    const translate = status[value];
    return translate;
  }
}
